'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keymirror2.default)({
  HORIZONTAL: null,
  RECTANGLE: null,
  VERTICAL: null,
  MOBILE: null,
  MOBILE_BIG: null,
  MOBILE_HORIZONTAL: null,
  PORTRET: null,
  BILBORD: null
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-google-publisher-tag/dist/constants/Format.js
 ** module id = 133
 ** module chunks = 0
 **/